import type { FaireProductEntity } from "../../entity_types/product";

export const p_ng8hns65vx: FaireProductEntity = {
  token: "p_ng8hns65vx",
  type: "product",
  name: "Lavender Lemongrass Magnesium Tallow Whip",
  brandToken: "b_6qmzxvyma9",
  brandName: "Wild Roots Tallow Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f7e16d77f360990a8611bb5a39feb6a0f5ca9e9ee33c1f1dd72f3818e3258bc7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/565428663ae09c125d4ae677f6b9b661f3721a8d4536affd49aabbc6d3249ad6.jpeg",
    "https://cdn.faire.com/fastly/3a456014d5e0316133dcbdb6006c7e41374bbaf95f8603dccb4bdd925188d3f7.jpeg",
    "https://cdn.faire.com/fastly/ac48d3a6590ea3ea033fc64005ac2f3c7c04958d020c4648f2da5f59015b62a5.png",
    "https://cdn.faire.com/fastly/f8ef287ee446933273bcdab6d263018163eb9ad1fdcc79a70c28bc64fdfc4da4.png",
    "https://cdn.faire.com/fastly/5eb676c0bd1095e5a677e81ed9e70b394ff6350c29ad8319741e664df7377173.png",
    "https://cdn.faire.com/fastly/0750423988f912ea0f08858b97859547419bedaca614ed05f5b04300ab7c80fa.png",
    "https://cdn.faire.com/fastly/740793bd5ef3fe42b4aedad945757018656c49b9b6ab52037cbe52b2c87941c6.png",
  ],
  priceDollars: 24.94,
  description:
    "A whipped magnesium tallow cream with lavender and lemongrass to support relaxation, muscle comfort, and deeply nourished skin.\n\nInfused with magnesium oil, this whip is ideal for evening routines, post-workout recovery, or anytime the body needs extra support. Organic cold-pressed coconut oil adds lightweight hydration, while lavender, lemongrass, and ylang ylang essential oils create a calming yet uplifting aroma that encourages relaxation and balance.\n\nKey Benefits\nSupports relaxation and muscle comfort\nWhipped texture absorbs quickly\nDeeply moisturizes and softens skin\nIdeal for nighttime or post-activity use\nCalming floral-citrus aroma\n\nWhy Retailers Love It\nMagnesium body products are high-performing in wellness retail. This tallow-based whip appeals to customers seeking natural recovery support, clean ingredients, and low-tox body care. Perfect for wellness shops, yoga studios, and spa retailers.\n\nHow to Use\nMassage a small amount into clean skin, focusing on legs, shoulders, or areas of tension. Best used in the evening or after physical activity.\n",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:58.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
